/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiRoomParticipantFromJSON(json) {
    return StreemApiRoomParticipantFromJSONTyped(json, false);
}
export function StreemApiRoomParticipantFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'userSid': !exists(json, 'user_sid') ? undefined : json['user_sid'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'isExpert': !exists(json, 'is_expert') ? undefined : json['is_expert'],
    };
}
export function StreemApiRoomParticipantToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'user_sid': value.userSid,
        'status': value.status,
        'is_expert': value.isExpert,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiRoomParticipantStatus;
(function (StreemApiRoomParticipantStatus) {
    StreemApiRoomParticipantStatus["ACTIVE"] = "STATUS_ACTIVE";
    StreemApiRoomParticipantStatus["CONNECTED"] = "STATUS_CONNECTED";
    StreemApiRoomParticipantStatus["INVALID"] = "STATUS_INVALID";
    StreemApiRoomParticipantStatus["LEFT"] = "STATUS_LEFT";
    StreemApiRoomParticipantStatus["NEVERARRIVED"] = "STATUS_NEVER_ARRIVED";
    StreemApiRoomParticipantStatus["PENDING"] = "STATUS_PENDING";
    StreemApiRoomParticipantStatus["RECONNECTING"] = "STATUS_RECONNECTING";
})(StreemApiRoomParticipantStatus || (StreemApiRoomParticipantStatus = {}));
//# sourceMappingURL=StreemApiRoomParticipant.js.map